import { Box, Grid } from '@mui/material';
import { CardButton, CardUserInfo } from 'components';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useToken } from 'stores';

const container = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,
		transition: {
			staggerChildren: 0.15,
		},
	},
	exit: { opacity: 0, transition: { duration: 0.2 } },
};

const item = {
	hidden: { x: window.innerWidth / 2, opacity: 0 },
	show: { x: 0, opacity: 1 },
};

const User = () => {
	const { t } = useTranslation();
	const { userToken } = useToken();

	return (
		<>
			<Box
				p={2}
				pt={0}
				sx={{
					overflowX: 'hidden',
					overflowY: 'scroll',
					maxHeight: 'calc(100% - 48px)',
				}}
			>
				<Grid
					container
					spacing={2}
					component={motion.div}
					variants={container}
					initial="hidden"
					animate="show"
					exit="exit"
				>
					<Grid item xs={12} component={motion.div} variants={item}>
						<CardUserInfo />
					</Grid>
					{userToken ? (
						<Grid
							item
							xs={12}
							component={motion.div}
							variants={item}
						>
							<CardButton showArrow={true} to={'/Redeem'}>
								{t('nav.redeem')}
							</CardButton>
						</Grid>
					) : null}
					<Grid item xs={12} component={motion.div} variants={item}>
						<CardButton showArrow={true} to={'/ContactUs'}>
							{t('nav.contact')}
						</CardButton>
					</Grid>
					<Grid item xs={12} component={motion.div} variants={item}>
						<CardButton showArrow={true} to={'/Settings'}>
							{t('nav.settings')}
						</CardButton>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default User;
